module.exports = __webpack_public_path__ + "static/media/highlightClaim.405ab983.svg";